import { Controller } from "@hotwired/stimulus"

// Bulk Selection Controller
// Manages checkbox selection and bulk actions UI
// Usage: data-controller="bulk-select" on parent element
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "counter", "actionsBar"]

  connect() {
    this.updateUI()
  }

  // Toggle individual checkbox and update UI
  toggle(event) {
    this.updateUI()
  }

  // Toggle all checkboxes
  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateUI()
  }

  // Deselect all checkboxes (for cancel button)
  deselectAll(event) {
    event.preventDefault()
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = false
    }
    this.updateUI()
  }

  // Update counter and show/hide actions bar
  updateUI() {
    const selectedCount = this.selectedCheckboxes.length
    const totalCount = this.checkboxTargets.length

    // Update counter
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = selectedCount
    }

    // Show/hide actions bar
    if (this.hasActionsBarTarget) {
      if (selectedCount > 0) {
        this.actionsBarTarget.classList.remove('hidden')
      } else {
        this.actionsBarTarget.classList.add('hidden')
      }
    }

    // Update "select all" checkbox state
    if (this.hasSelectAllTarget) {
      if (selectedCount === 0) {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = false
      } else if (selectedCount === totalCount) {
        this.selectAllTarget.checked = true
        this.selectAllTarget.indeterminate = false
      } else {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = true
      }
    }
  }

  // A bulk form sits outside the table, so copy the selected ids into it as hidden inputs on submit
  // (data-bulk-select-param names the field, e.g. "ad_ids[]").
  fill(event) {
    const form = event.target
    form.querySelectorAll("input[data-bulk-select-generated]").forEach((input) => input.remove())
    const name = form.dataset.bulkSelectParam || "ids[]"
    this.selectedValues.forEach((value) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = name
      input.value = value
      input.dataset.bulkSelectGenerated = ""
      form.appendChild(input)
    })
  }

  // Get selected checkbox values (for form submission)
  get selectedValues() {
    return this.selectedCheckboxes.map(cb => cb.value)
  }

  // Get selected checkboxes
  get selectedCheckboxes() {
    return this.checkboxTargets.filter(cb => cb.checked)
  }
}
